import React, { useState } from "react"
import { Tooltip } from "reactstrap"

function TraderBadge({ companyCategory, id: propId }) {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const targetId = propId || "TraderBadgeIcon"

  return (
    <div>
      {companyCategory === "Trader" && (
        <>
          <i
            className="text-info bx bx-store font-size-18 ms-1"
            id={targetId}
            onMouseOver={() => setTooltipOpen(true)}
            onMouseOut={() => setTooltipOpen(false)}
          />
          <Tooltip
            placement="right"
            isOpen={tooltipOpen}
            target={targetId}
          >
            Trader
          </Tooltip>
        </>
      )}
    </div>
  )
}

export default TraderBadge
